import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/layout/PublicLayout";
import AuthCallback from "@/components/AuthCallback";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";

import Home from "@/pages/Home";
import About from "@/pages/About";
import CodeOfConduct from "@/pages/CodeOfConduct";
import CertificationProcess from "@/pages/CertificationProcess";
import ChecklistPage from "@/pages/ChecklistPage";
import AssessmentCriteria from "@/pages/AssessmentCriteria";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import Disclaimer from "@/pages/Disclaimer";
import Verify from "@/pages/Verify";
import CertificateView from "@/pages/CertificateView";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import Dashboard from "@/pages/Dashboard";
import ApplyStart from "@/pages/ApplyStart";
import ApplicationWizard from "@/pages/ApplicationWizard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminReview from "@/pages/AdminReview";
import AdminUsers from "@/pages/AdminUsers";
import AdminPromoCodes from "@/pages/AdminPromoCodes";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: process Google OAuth return (session_id in URL fragment) before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route element={<PublicLayout />}>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/code-of-conduct" element={<CodeOfConduct />} />
        <Route path="/certification-process" element={<CertificationProcess />} />
        <Route path="/questionnaire-document-checklist" element={<ChecklistPage />} />
        <Route path="/assessment-criteria" element={<AssessmentCriteria />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/certificate/:certId" element={<CertificateView />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />

        {/* Applicant */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/apply" element={<ProtectedRoute><ApplyStart /></ProtectedRoute>} />
        <Route path="/applications/:id" element={<ProtectedRoute><ApplicationWizard /></ProtectedRoute>} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />

        {/* Admin */}
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/promo-codes" element={<ProtectedRoute adminOnly><AdminPromoCodes /></ProtectedRoute>} />
        <Route path="/admin/applications/:id" element={<ProtectedRoute adminOnly><AdminReview /></ProtectedRoute>} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
